import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { FileCategory } from '@/models/binder-file';
import { DocGeneratorService } from '@/services/api/doc-generator.service';
import { SelectedDocService } from '@/services/app/selected-doc.service';
import { FilesService } from '@/services/api/files.service';
import { BinderService } from '@/services/api/binder.service';


interface UploadEvent {
  originalEvent: Event;
  files: File[];
}

@Component({
    selector: 'app-add-files',
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        FileUploadModule,
        ButtonModule,
        ToastModule
    ],
    standalone: true,
    template: `
    <div class="form-container" #pnl>
    <div class="form-field" *ngIf="!fileCategory">
        <label for="fileType">File Type</label>
        <p-select id="fileType" [options]="categories" [(ngModel)]="selectedCategory" optionLabel="fileCategoryName"
            placeholder="Select a Category">
        </p-select>
    </div>
    <div class="form-field">
        <label>File</label>
        <p-fileUpload *ngIf="getCategory()?.interactType === 'upload'" mode="basic" chooseLabel="Choose"
            chooseIcon="pi pi-upload" accept="image/*, application/pdf" maxFileSize="100000000"
            [uploadStyleClass]="'p-button-secondary'" [chooseStyleClass]="'p-button-secondary'" [customUpload]="true"
            [auto]="true" (uploadHandler)="onUpload($event)" />

        <p-fileUpload *ngIf="getCategory()?.interactType === 'uploadMany'" [customUpload]="true"
            (uploadHandler)="onUpload($event)" name="demo[]" [auto]="true" chooseLabel="Browse" [multiple]="true"
            accept="image/*, application/pdf" maxFileSize="100000000">
            <ng-template pTemplate="content">
                <ul *ngIf="uploadedFiles.length">
                    <li *ngFor="let file of uploadedFiles">
                        {{ file.name }} - {{ file.size }} bytes
                    </li>
                </ul>
            </ng-template>
        </p-fileUpload>
    </div>
    <div class="form-field">
        <button type="button" pButton icon="pi pi-Check" label="Upload" class="p-button-primary" (click)="uploadFiles()"
            [disabled]="!isValid()"></button>
    </div>
</div>
<p-toast />
    `
})
export class AddFileComponent {

  docGenerator = inject(DocGeneratorService);
  selectedDocService = inject(SelectedDocService);
  filesService = inject(FilesService);
  currentBinderService = inject(BinderService);
  messageService = inject(MessageService);

  uploadedFiles: any[] = [];
  uploadedFile: any[] = [];
  @Input() fileId: string | null = null;
  @Input() fileCategory: FileCategory | null = null;
  @Output() uploadComplete = new EventEmitter<boolean>();
  loading:boolean =false;

  constructor(
    
  ) { }

  get categories() {
    return this.filterCategories(this.filesService.categories());
  }

  get selectedCategory(): FileCategory | null {
    return this.filesService.viewedCategory();
  }

  set selectedCategory(category: FileCategory) {
    this.filesService.viewedCategory.set(category);
  }

  filterCategories(categories: FileCategory[]) {
    return categories.filter(category => category.interactType === 'upload' || category.interactType === 'uploadMany');
  }

  onUpload(event:any) {
    console.log('onUpload', event);
    if(this.selectedCategory?.interactType === 'uploadMany') {
      for(let file of event.files) {
          this.uploadedFiles.push(file);
      }
    } else {
      this.uploadedFile = event.files;
    }
}


getCategory(): FileCategory | null {
  return this.fileCategory ? this.fileCategory : this.selectedCategory ?? null;
}

isValid(): boolean {
  const catId = this.getCategory()?.fileCategoryId;
  let files = false 
  if(this.selectedCategory?.interactType === 'uploadMany') {
    files = this.uploadedFiles.length > 0;
  } else {
    files = this.uploadedFile.length > 0;
  }
  return catId !== null && files;
}

getFileId(): string | null {
  const category = this.getCategory();
  if(category?.interactType === 'upload') {
    const id = category.binderFiles?.[0]?.fileId ?? null;
    if(id) {
      return id;
    } else {
      return this.fileId;
    }
  }
  return this.fileId;
}

uploadFiles() {
  this.loading = true;
  const catId = this.getCategory()?.fileCategoryId;
  if(catId) {
  if(this.selectedCategory?.interactType === 'uploadMany') {
    this.filesService.uploadMultipleFiles(this.currentBinderService.currentBinder().BinderID, this.uploadedFiles, catId).subscribe({
      next: (files) => {
        this.filesService.mergeFilesIntoCategory(catId, files);
        // make this load
        this.uploadComplete.emit(true);
        this.loading = false;
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error uploading files'});
        this.loading = false;
      }
    });
  } else {
    const id = this.getFileId();
    console.log('id', id);
    this.filesService.uploadSingleFile(this.currentBinderService.currentBinder().BinderID, this.uploadedFile[0], catId, id).subscribe({
      next: (files) => {
        this.filesService.mergeFilesIntoCategory(catId, files);
        
        this.uploadComplete.emit(true);
        this.loading = false;
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error uploading files'});
        this.loading = false;
      }
    });
  }
  console.log(this.uploadedFiles);
}
else {
  console.log('no category id');
  this.messageService.add({severity:'error', summary:'Error', detail:'Please select a category'});
  this.loading = false;
}
}

}
